import * as React from 'react';

import { inject } from 'mobx-react';
import { parseUrl } from 'query-string';

import { EStore } from '@enums';

import { URLS } from '@base/constants';

import { ButtonDefault } from '@ui';

import { IMainProps, IMainState } from './types';

import * as s from './Main.scss';

@inject(EStore.CURRENT_USER)
export class Main extends React.Component<IMainProps, IMainState> {

	state: IMainState = {
		login: '',
		domain: 'mail.ru',
		password: '',
		error: '',
		isLoading: false,
	};

	onLoginChange = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({ login: event.target.value });

	onPasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => this.setState({ password: event.target.value });

	onDomainChange = (event: React.ChangeEvent<HTMLSelectElement>) => this.setState({ domain: event.target.value });

	onSubmit = async () => {
		const {
			login,
			password,
			domain,
		} = this.state;
		const { query } = parseUrl(location.href);

		this.setState({
			isLoading: true,
			error: '',
		});

		try {
			await this.props.currentUserStore.localAuth({
				login,
				password,
				domain,
			});
			location.href = query.page ? query.page as string : `${location.origin}${URLS.APPS}`;
		} catch (err) {
			this.setState({
				error: 'Wrong login or password',
			});
		} finally {
			this.setState({
				isLoading: false,
			});
		}
	};

	render() {
		const {
			currentUser,
		} = this.props.currentUserStore;

		return (
			<div className={s.block}>
				<input placeholder={currentUser.email || 'login'} onChange={this.onLoginChange}/>
				<br/>
				<select onChange={this.onDomainChange}>
					<option value="mail.ru" selected>@mail.ru</option>
					<option value="inbox.ru">@inbox.ru</option>
					<option value="bk.ru">@bk.ru</option>
					<option value="list.ru">@list.ru</option>
				</select>
				<br/>
				<input placeholder="password" type="password" onChange={this.onPasswordChange}/>
				<br/>
				<ButtonDefault onClick={this.onSubmit}>sumbit</ButtonDefault>
				{!!this.state.isLoading && <> <br/><span>loading...</span></>}
				{!!this.state.error?.length && <> <br/><span style={{ color: 'red' }}>{this.state.error}</span></>}
			</div>
		);
	}

}
